export default __webpack_public_path__ + "static/media/Group848.d489d2f8.svg";